import Cart from '../../services/Cart';
import CartJs from '../../../js/site/cart.js';

export default {
    namespaced: false,

    state: {
        cart: {},
        addToCartLoading: false,
        loadingId: null
    },

    mutations: {
        SET_CART_LOADING(state) {
            state.addToCartLoading = !state.addToCartLoading;
        },
        SET_CART_DATA(state, data) {
            state.cart = data;
        },
        PLUS_TO_CART(state, id) {
            const qty = parseInt(state.cart[id] || 0) + 1;
            state.cart = { ...state.cart, [id]: qty }; // this is for VUE to trigger change
        },
        MINUS_TO_CART(state, id) {
            const qty = parseInt(state.cart[id] || 0) - 1;
            if (qty > 0) {
                state.cart = { ...state.cart, [id]: qty };
            } else {
                delete state.cart[id];
                state.cart = { ...state.cart };
            }
        },
        SET_LOADING_ID(state, id) {
            state.loadingId = id;
        },
        TO_CART(state, obj) {
            if (parseInt(obj.val) === 0) {
                delete state.cart[obj.id];
                state.cart = { ...state.cart };
            } else {
                state.cart = { ...state.cart, [obj.id]: obj.val }; // this is for VUE to trigger change
            }
        }
    },

    actions: {
        addToCart({ commit, getters }, obj) {
            commit('SET_CART_LOADING');
            const response = Cart.addToCart(obj);
            response.then(res => {
                document.getElementById('cartId').innerHTML = res.data;
                if (res.data > 99) {
                    document.getElementById('cartId').classList.add('bigger');
                } else {
                    document
                        .getElementById('cartId')
                        .classList.remove('bigger');
                }
                commit('PLUS_TO_CART', obj.id);
                commit('SET_CART_LOADING');
                CartJs.updateCartTableRowQty(obj.id, getters.getCart[obj.id]);
                CartJs.refreshCart();
            });
        },
        removeFromCart({ commit, getters }, obj) {
            commit('SET_CART_LOADING');
            const response = Cart.removeFromCart(obj);
            response.then(res => {
                document.getElementById('cartId').innerHTML = res.data;
                if (res.data > 99) {
                    document.getElementById('cartId').classList.add('bigger');
                } else {
                    document
                        .getElementById('cartId')
                        .classList.remove('bigger');
                }
                commit('SET_CART_LOADING');
                commit('MINUS_TO_CART', obj.id);
                CartJs.updateCartTableRowQty(obj.id, getters.getCart[obj.id]);
                CartJs.refreshCart();
            });
        },
        getAllCart({ commit }) {
            commit('SET_CART_LOADING');
            const response = Cart.getAllCart();
            response.then(res => {
                commit('SET_CART_DATA', res.data);
                commit('SET_CART_LOADING');
            });
        },
        getCartById({ commit }, obj) {
            commit('SET_CART_LOADING');
            const response = Cart.getCartById(obj);
            response.then(res => {
                commit('SET_CART_DATA', res.data);
                commit('SET_CART_LOADING');
            });
        },
        addMany({ commit }, obj) {
            commit('SET_CART_LOADING');
            const response = Cart.addMany(obj);
            response.then(res => {
                document.getElementById('cartId').innerHTML = res.data;
                if (res.data > 99) {
                    document.getElementById('cartId').classList.add('bigger');
                } else {
                    document
                        .getElementById('cartId')
                        .classList.remove('bigger');
                }
                commit('TO_CART', obj);
                commit('SET_CART_LOADING');
                commit('SET_LOADING_ID', null);
            });
        },
        async setLoadingId({ commit }, id) {
            await commit('SET_LOADING_ID', id);
        },
        addManySlider({ commit }, obj) {
            commit('SET_CART_LOADING');
            const response = Cart.addMany(obj);
            response.then(res => {
                document.getElementById('cartId').innerHTML = res.data;
                if (res.data > 99) {
                    document.getElementById('cartId').classList.add('bigger');
                } else {
                    document
                        .getElementById('cartId')
                        .classList.remove('bigger');
                }
                commit('TO_CART', obj);
                commit('SET_CART_LOADING');
                CartJs.updateCartTableRowQty(obj.id, obj.val);
                CartJs.refreshCart();
            });
        },

        addManyFromCart({ commit }, obj) {
            commit('PLUS_TO_CART', obj.id);
        },

        minusManyFromCart({ commit }, obj) {
            commit('MINUS_TO_CART', obj.id);
        },

        addManyAndRefreshCart({ commit, getters }, obj) {
            commit('SET_CART_LOADING');
            const response = Cart.addMany(obj);
            response.then(res => {
                document.getElementById('cartId').innerHTML = res.data;
                if (res.data > 99) {
                    document.getElementById('cartId').classList.add('bigger');
                } else {
                    document
                        .getElementById('cartId')
                        .classList.remove('bigger');
                }
                commit('TO_CART', obj);
                commit('SET_CART_LOADING');
                CartJs.updateCartTableRowQty(obj.id, getters.getCart[obj.id]);
                CartJs.refreshCart();
            });
        }
    },

    getters: {
        getCart(state) {
            return state.cart;
        }
    }
};
